import React, {FunctionComponent, useMemo} from "react";
import {BackgroundShape} from "../backgroundShape/backgroundShape.component";
import {SectionWithBackgroundShape} from "../../interfaces/sectionWithBackgroundShape.interface";
import {StrapiImageData} from "../../interfaces/strapi/strapiImage.interface";
import {SectionPadding} from "../../enums";
import {AboutCardText, AboutCardTextProps} from "./aboutCardText/aboutCardText.component";

const styles = require("./aboutCard.component.scss");

interface AboutMWCardProps extends SectionWithBackgroundShape{
    aboutCardText: AboutCardTextProps[];
    aboutCardImage: StrapiImageData;
    sectionPadding: SectionPadding;
    reverseDirection?: boolean;
}


export const AboutCard: FunctionComponent<AboutMWCardProps> = props => {
    const {aboutCardText, aboutCardImage, reverseDirection, sectionPadding, backgroundShape, children} = props;

    const isTitle = useMemo(() => aboutCardText ? aboutCardText.length === 1 : false, [aboutCardText]);

    return (
        <div className={styles.cardBackground}>
            {!!backgroundShape &&
                <BackgroundShape {...backgroundShape}/>
            }
            <div className={`${styles.cardWrapper} ${sectionPadding ? styles[sectionPadding] : ''} ${reverseDirection ? styles.left : styles.right} 
            ${reverseDirection ? styles.reverseDirection : ''}`}>
                <div className={styles.cardContainer}>
                    <div className={styles.cardTextContainer}>
                        {children}
                        <div className={styles.cardSubTextContainer}>
                            {aboutCardText && aboutCardText.map((cardTextData, index) =>
                                    <AboutCardText key={index} {...cardTextData} asTitle={isTitle}/>
                            )}
                        </div>
                    </div>
                    <div className={styles.cardImage}>
                        <img className={styles.middleImg} src={aboutCardImage?.url} alt=""/>
                    </div>
                </div>
            </div>
        </div>
    );
};
